import React, { useEffect, useState } from "react";
import alertService from "../../_services/cart/alert.service";
import suscripcionService from "../../_services/cart/suscripcion.service";

const mesActual = () => {
    const hoy = new Date();
    return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, "0")}`;
};

/**
 * Cuanto usa cada cuenta el "Completar con IA" en el mes. Por ahora solo se mide: es para ver con
 * datos si conviene ponerle un tope por plan.
 */
export const UsoIaAdmin = () => {
    const [mes, setMes] = useState(mesActual());
    const [cuentas, setCuentas] = useState([]);
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        setCargando(true);
        suscripcionService
            .adminUsoIa(mes)
            .then((r) => setCuentas(r.cuentas || []))
            .catch((err) => alertService.error(err))
            .finally(() => setCargando(false));
    }, [mes]);

    const total = (campo) => cuentas.reduce((s, c) => s + Number(c[campo] || 0), 0);
    const usd = (n) => "US$ " + Number(n).toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 4 });

    return (
        <section className="cuenta-usuarios__card cuenta-usuarios__tabla-card">
            <div className="uso-ia__cabecera">
                <div>
                    <p className="cuenta-usuarios__eyebrow">Asistente con IA</p>
                    <p className="panel__bajada">
                        Consultas de "Completar con IA" y tipos nuevos aceptados, por cuenta. Las fallidas también cuentan
                        (se intentó y la IA no respondió).
                    </p>
                </div>
                <div>
                    <label className="cuenta-usuarios__label" htmlFor="uso-ia-mes">Mes</label>
                    <input id="uso-ia-mes" type="month" className="cuenta-usuarios__select" value={mes}
                           max={mesActual()} onChange={(e) => e.target.value && setMes(e.target.value)} />
                </div>
            </div>

            {cargando && <p className="panel__estado-carga">Cargando…</p>}
            {!cargando && cuentas.length === 0 && <p className="cuenta-usuarios__vacio">Nadie usó el asistente en ese mes.</p>}
            {!cargando && cuentas.length > 0 && (
                <div className="suscripcion-admin__tabla">
                    <table className="cuenta-usuarios__tabla">
                        <thead>
                            <tr>
                                <th>Cuenta</th>
                                <th>Consultas</th>
                                <th>Fallidas</th>
                                <th>Tipos nuevos</th>
                                <th>Tokens</th>
                                <th>Costo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cuentas.map((c) => (
                                <tr key={(c.cuentaId ?? "sin") + c.cuenta}>
                                    <td>{c.cuenta}</td>
                                    <td>{c.consultas}</td>
                                    <td>{c.fallidas}</td>
                                    <td>{c.tiposSugeridos}</td>
                                    <td>{(Number(c.tokensEntrada) + Number(c.tokensSalida)).toLocaleString("es-AR")}</td>
                                    <td>{usd(c.costoUsd)}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th>Total</th>
                                <th>{total("consultas")}</th>
                                <th>{total("fallidas")}</th>
                                <th>{total("tiposSugeridos")}</th>
                                <th>{(total("tokensEntrada") + total("tokensSalida")).toLocaleString("es-AR")}</th>
                                <th>{usd(total("costoUsd"))}</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}
        </section>
    );
};
